// src/hooks/useNotificationCenter.ts
import { useState } from 'react';
import { useNotifications } from '../contexts/NotificationContext';

export function useNotificationCenter() {
  const [opened, setOpened] = useState(false);
  const notifications = useNotifications();
  
  const openNotificationCenter = () => setOpened(true);
  const closeNotificationCenter = () => setOpened(false);
  const toggleNotificationCenter = () => setOpened(prev => !prev);
  
  return {
    opened,
    openNotificationCenter,
    closeNotificationCenter,
    toggleNotificationCenter,
    ...notifications,
  };
}